export default __webpack_public_path__ + "static/media/BxBxsCheckCircle 1.3937a155.svg";